/**
 * This script makes the `.custom-product-header` element stick after the main header
 * once the user scrolls down.
 */
document.addEventListener('DOMContentLoaded', () => {
  const headerWrapper = document.querySelector('.header-wrapper');
  const productHeader = document.querySelector('.custom-product-header');
  if (!headerWrapper) return;

  // 1) Measure the height of Shopify's header wrapper
  const headerH = headerWrapper.clientHeight;

  // 2) Expose it to CSS as --main-header-height
  document.documentElement.style.setProperty('--main-header-height', `${headerH}px`);

  // 3) When you scroll past it, add .is‑sticky to your nav
  window.addEventListener('scroll', () => {
    if (window.scrollY >= headerH) {
      productHeader.classList.add('is-sticky');
    } else {
      productHeader.classList.remove('is-sticky');
    }
  });

  // // 3) If you still want to auto-close mega‑menus on scroll:
  // const detailsItems = document.querySelectorAll('details.mega-menu');
  // window.addEventListener('scroll', () => {
  //   detailsItems.forEach((d) => d.removeAttribute('open'));
  // });
});
